import {
  SET_USER_AUTHENTICATED,
  SET_USER_LOADING,
} from '../actions/actionTypes';

const initialState = {
  authenticated: false,
  loading: false,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_AUTHENTICATED:
      return {
        ...state,
        ...action.payload,
      };
    case SET_USER_LOADING:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
